import { useSelector, shallowEqual } from 'react-redux';
import moment from 'moment';

import { useMeterType } from 'hooks/useMeterType';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { FMRS } from 'config/app-config';
import { selectData as selectFmrsData } from 'state/fmrs/fmrs-slice';
import { DATE_FORMAT } from 'config/app-config';
import { usePaymentMethod } from './usePaymentMethod';

export const getDefaultMinSsd = (mDate) => {
  if (!mDate) {
    return;
  }

  const result = mDate.isValid() ? mDate : moment();

  return result.format(DATE_FORMAT);
};

export const useFmrs = () => {
  const { isPrePay } = usePaymentMethod();
  const fuelType = useSelector(selectFuelType, shallowEqual);
  const {
    gasMeter = {},
    electricityMeter = {},
    hasAnyTOUMeter
  } = useMeterType();
  const today = moment();
  const mGasMinSSD = moment(gasMeter.minimumSupplyStartDate, DATE_FORMAT);

  const mElectricityMinSSD = moment(
    electricityMeter.minimumSupplyStartDate,
    DATE_FORMAT
  );

  const dualFuelMinSSD = moment.max([mGasMinSSD, mElectricityMinSSD]);
  const daysToAdd =
    isPrePay && hasAnyTOUMeter
      ? FMRS.MIN_SUPPLY_START_DAYS_COUNT_PAYG_SMART
      : 0;

  let minimumSupplyStartDate;

  switch (true) {
    case fuelType.gas && fuelType.electric:
      minimumSupplyStartDate = getDefaultMinSsd(
        dualFuelMinSSD.add(daysToAdd, 'days')
      );
      break;
    case fuelType.gas:
      minimumSupplyStartDate = getDefaultMinSsd(
        mGasMinSSD.add(daysToAdd, 'days')
      );
      break;
    default:
      minimumSupplyStartDate = getDefaultMinSsd(
        mElectricityMinSSD.add(daysToAdd, 'days')
      );
  }

  const maximumSupplyStartDate = moment(today)
    .add(FMRS.MAX_SUPPLY_START_DAYS_COUNT, 'days')
    .format(DATE_FORMAT);

  const billingConsentMinDate = moment(today).add(
    FMRS.BILLING_CONSENT_DAYS_COUNT,
    'days'
  );

  const { preferredStartDate, billingConsent } = useSelector(
    selectFmrsData,
    shallowEqual
  );

  const requiresBillingConsent = !moment(preferredStartDate).isAfter(
    billingConsentMinDate
  );

  return {
    minimumSupplyStartDate,
    maximumSupplyStartDate,
    billingConsentMinDate,
    requiresBillingConsent,
    preferredStartDate: preferredStartDate || minimumSupplyStartDate,
    billingConsent
  };
};
